<template>
  <div class="border border-gray-400 overflow-hidden markdown">
    <div class="w-full bg-gray-400 text-white p-1">{{ $t("news.manage.markdown_preview") }}</div>
    <div class="p-4">
      <vue-markdown
        :source="text"
        :anchorAttributes="{
          target: '_blank',
          rel: 'nofollow',
        }"
      />
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  name: "MarkdownPreviewBox",
  data() {
    return {};
  },
  props: {
    text: {
      type: String
    }
  },
  components: {
    VueMarkdown
  },
  methods: {},
  computed: {},
  created() {}
};
</script>
